// Language constants that can be used on both client and server
export const languages = ['nl', 'vl', 'fr', 'en', 'de', 'ja'] as const
export type Language = (typeof languages)[number]

// Language display names
export const languageNames: Record<Language, string> = {
	nl: 'Nederlands',
	vl: 'Vlaams',
	fr: 'Français',
	en: 'English',
	de: 'Deutsch',
	ja: '日本語',
}
